import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, inlineLinkClass } from '../ui';

/**
 * F13: shown under the "Was"/"Merkmale" group titles for Free users — filters can already be
 * set, but only take effect from Pro onward. Warmmiete bis is always applied and gets no badge
 * of its own (rendered outside this component, by the caller).
 */
export const FreeTierHint: React.FC = () => (
  <div className="mb-4 flex flex-col gap-1.5">
    {/* self-start: the flex-col parent stretches children by default, which
        would otherwise blow the badge up to the full container width (e.g.
        in the narrow /tg layout). */}
    <Badge tone="brand" className="self-start">wird ab Pro angewendet</Badge>
    <p className="text-sm text-muted">
      Du kannst Filter schon einstellen. Angewendet werden sie ab Pro, bis dahin bekommst du alle Treffer in deinen PLZ
      und einen Hinweis, was gefiltert würde.{' '}
      <Link to="/dashboard/upgrade" className={inlineLinkClass}>Pro ansehen</Link>
    </p>
  </div>
);
